import axiosGo from "./axiosGo";

export const assetApi = {
    getAssetGroupsByTier: (tierId: string) => {
        const url = `asset/api/v1/asset-groups/tier/${tierId}`;
        return axiosGo.get(url);
    },

    getCarsByUserID: () => {
        const url = `asset/api/v1/assets/grouped/slug/car`;
        return axiosGo.get(url);
    },

    getTierByUserID: (userId: string) => {
        const url = `user/api/v1/user-tier-config/${userId}`;
        return axiosGo.get(url);
    },

    addCar: (
        asset_group_id: string | undefined,
        formData: {
            licensePlate: string;
            province: string;
            carBrand: string;
            model: string;
            color: string;
        }
    ) => {
        const url = "asset/api/v1/assets";
        const customFields = [
            {
                slug: "car_plate",
                value: formData.licensePlate,
            },
            {
                slug: "car_plate_province",
                value: formData.province,
            },
            {
                slug: "brand",
                value: formData.carBrand,
            },
            {
                slug: "car_model",
                value: formData.model,
            },
            {
                slug: "car_color",
                value: formData.color,
            },
        ];

        const reqPayload = {
            asset_group_id: asset_group_id,
            custom_fields: customFields,
        };

        return axiosGo.post(url, reqPayload);
    },

    editCar: (
        assetId: string,
        asset_group_id: string,
        is_active: boolean,
        formData: {
            licensePlate: string;
            province: string;
            carBrand: string;
            model: string;
            color: string;
        }
    ) => {
        const url = `asset/api/v1/assets/${assetId}`;
        const customFields = [
            {
                slug: "car_plate",
                value: formData.licensePlate,
            },
            {
                slug: "car_plate_province",
                value: formData.province,
            },
            {
                slug: "brand",
                value: formData.carBrand,
            },
            {
                slug: "car_model",
                value: formData.model,
            },
            {
                slug: "car_color",
                value: formData.color,
            },
        ];

        const reqPayload = {
            asset_id: assetId,
            asset_group_id: asset_group_id,
            custom_fields: customFields,
            is_active: is_active,
        };

        return axiosGo.patch(url, reqPayload);
    },

    deleteCar: (assetId: string, tierID: string) => {
        const url = `asset/api/v1/assets/${assetId}/tier/${tierID}`;
        return axiosGo.delete(url);
    },
};
